<template>
    <div class="fees">
        <section class="home-cards">
        <h4>School Buses Routes and Times</h4>
        <hr class="hr">
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/school-bus.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>Nyumba Yanga Bus Route</h5>
                </div>
                <div class="feature-detail">
                  <h6>Rodrick Phiri - Contact: 0971751245</h6>
                  <table>
                    <tr>
                        <th>S/N</th>
                        <th>STATION</th>
                        <th>TIME</th>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Kabulonga Sable Road</td>
                        <td>5:50</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>The Bag - Mtendere East</td>
                        <td>6:10</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>ZAF 71</td>
                        <td>6:20</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Bauleni -Kamanda</td>
                        <td>6:30</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td> Nyumba Yanga Taxi Rank</td>
                        <td>6:40</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td> Nyumba Yanga Police</td>
                        <td>6:45</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>Container</td>
                        <td>6:50</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>Boarder View</td>
                        <td>7:00</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>Buffcon Lodge</td>
                        <td>7:20</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td> Mpala Compex</td>
                        <td>7:25</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Arrival at inspire</td>
                        <td>7:45</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Depature from Inspire(Mon-Thu)</td>
                        <td>3:00(pm)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Depature from Inspire(Fri)</td>
                        <td>12:30(pm)</td>
                    </tr>
                    </table>
                </div>
            </div>
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/school-bus.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>Ring Road Chalala Bus Route</h5>
                </div>
                <div class="feature-detail">
                  <h6>Mike Mphonda - Contact: 0975472428</h6>
                  <table>
                    <tr>
                        <th>S/N</th>
                        <th>STATION</th>
                        <th>TIME</th>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>ZAF Staff College Kamwala</td>
                        <td>6:00</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Kangwa Bus Stop</td>
                        <td>6:10</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Water Works Bus Stop</td>
                        <td>6:25</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td> High Life Church</td>
                        <td>6:30</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Ring Road - Robots before overhead cameras</td>
                        <td>6:40</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>Chalala Mall</td>
                        <td>6:45</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>Mahopo Hospital</td>
                        <td>6:55</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td> Wisdom Wood School (B Wise)</td>
                        <td>7:05</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>Chalala Station</td>
                        <td>7:15</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>Glory Academy</td>
                        <td>7:20</td>
                    </tr>
                    <tr>
                        <td>11</td>
                        <td>Ring Road - Chris Corner Robots</td>
                        <td>7:30</td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>Junior Achievers</td>
                        <td>7:35</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Arrival at inspire</td>
                        <td>7:45</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Depature from Inspire(Mon-Thu)</td>
                        <td>3:00(pm)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Depature from Inspire(Fri)</td>
                        <td>12:30(pm)</td>
                    </tr>
                    </table>
                </div>
            </div>
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/school-bus.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>Chilenje Bus Route</h5>
                </div>
                <div class="feature-detail">
                  <h6>Victor Mapulanga - Contact: 0978873558</h6>
                  <table>
                    <tr>
                        <th>S/N</th>
                        <th>STATION</th>
                        <th>TIME</th>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>New Town Gate</td>
                        <td>6:00</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>New Town 2</td>
                        <td>6:05</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>New Town 3</td>
                        <td>6:10</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Chalala - Mungulu Market</td>
                        <td>6:20</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Chalala - White Shop</td>
                        <td>6:30</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>Chalala</td>
                        <td>6:40</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td> Chalala - Holy Cross School</td>
                        <td>6:50</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>Chilenje Kalomo Road</td>
                        <td>7:00</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td> Chilenje - Tick School</td>
                        <td>7:05</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>Francis Corner</td>
                        <td>7:10</td>
                    </tr>
                    <tr>
                        <td>11</td>
                        <td>Chilenje Police Camp</td>
                        <td>7:15</td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>Chilenje Market</td>
                        <td>7:17</td>
                    </tr>
                    <tr>
                        <td>13</td>
                        <td>Chilenje Chris Corner</td>
                        <td>7:20</td>
                    </tr>
                    <tr>
                        <td>14</td>
                        <td> Woodlands Mpala Complex</td>
                        <td>7:30</td>
                    </tr>
                    <tr>
                        <td>15</td>
                        <td> Woodlands - Behind Pacheche Lodge</td>
                        <td>7:40</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Arrival at inspire</td>
                        <td>7:45</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Depature from Inspire(Mon-Thu)</td>
                        <td>3:00(pm)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Depature from Inspire(Fri)</td>
                        <td>12:30(pm)</td>
                    </tr>
                    </table>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'SchoolBus',
  components: { }
}
</script>

<style>
.fees .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.fees .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.fees .home-cards .home-cards-main {
  padding: 1em;
  max-width: 600px;
  margin: 0 auto;
}
.fees .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.fees .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.fees .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.fees .feature p {
  color: var(--inspire-charcoal);
}
.fees .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.fees .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.fees .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
.fees .feature .feature-detail table {
  width: 100%;
}
</style>
